import { useDispatch, useSelector } from "react-redux"
import axios from "axios";
import { define } from '../data/globals'
import { useNotify } from '../hooks/useNotify';

// Удаление изображеняий, которые еще не сохранены в базе
// filesToBeDel - массив или строка (имена файлов)
// Если параметр не передан - удаляются все изображения (newPics), не сохраненные в базе
export function useDeletePics() {
    // Redux
    const dispath = useDispatch()
    const picsToDeleteStore = useSelector(state => state.picsToDelete)
    const newPicsStore = useSelector(state => state.newPics)
    
    const { pushNotify } = useNotify()
    

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Удаление файлов массива picsToDelete
    function delPicsToDelete() {
        if(picsToDeleteStore.length > 0) deleteFiles( picsToDeleteStore )
        // Очищаем массив
        dispath({ type: 'ClearPicsToDelete' })// this.picsToDelete = []
    }
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


    // // Удаление изображений, которые еще не сохранены в базе
    // // filesToBeDel - массив или строка (имена файлов)
    // // Если параметр не передан - удаляются все изображения (newPics), не сохраненные в базе
    async function deleteNewPics( filesToBeDel ) {

        // Если массив newPics пуст - прерываем функцию (поскольку нечего удалять)
        if(!newPicsStore.length) return

        if( typeof filesToBeDel === 'string' ) filesToBeDel = [filesToBeDel] // Удалим filesToBeDel (с сервера и из массива newPics)
        else filesToBeDel = newPicsStore // Удалим все загруженные файлы (с сервера и из массива newPics)

        let delResult = await deleteFiles( filesToBeDel )
        // Если функция deleteFiles не вернула массив прекращаем выполнение.
        if(!delResult) { 
            // console.log('deletedFiles - false'); 
            return
        }
        // ---------------------
        let tempArr = newPicsStore
        // Если в newPics есть такой элемент, то удалем
        for( let i = 0; i < delResult.length; i++) {
            // фильтруем массив
            tempArr = tempArr.filter(item => item !== delResult[i])
        }// for
        // Сохраняем результат в стор
        dispath({ type: 'SetNewProdPics', newPics: tempArr })

        // // Если newPics опустел - скрываем прогрессбар, очищаем input и т.п.
        // >>>> Это реализуется в компоненте Multiupload через useEffect
        // if(this.newPics.length === 0) this.hideBarAndClean()
        // // ---------------------

    }// deleteNewPics


    // Удаляет файлы (изображений) с диска сервера
    // filesToBeDel - массив, обязательный параметр (список файлов, которые нужно удалить)
    // Возвращает массив (имена файлов, удаление которых подтверждено сервером)
    async function deleteFiles( filesToBeDel ) {

        if( !filesToBeDel || typeof filesToBeDel === 'string' ) {
            console.log('Ошибка: функции deleteFiles не передан массив (обязательный параметр)')
            return }

        try {
            // let context = this
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/multiupload/delete_uplfiles.php',
                data: {
                    filesToBeDel: filesToBeDel
                },
                // headers: {
                //     "Content-type": "application/json; charset=UTF-8"
                // }
            })// axios

            // console.log('response: ', response);

            // проверка ответа от php файла
            if(response.data) {

                if(response.data.doneFiles.length === 0) {
                    console.log('~~~');
                    console.log('Нет подтверждения от сервера');
                    console.log('Комментарии: ', response.data.comments);
                    console.log('response: ', response);
                    console.log('~~~');
                    // alert('Нет подтверждения от сервера (см. консоль)')
                    pushNotify( 'Нет подтверждения от сервера (см. консоль)', 'notifyOrange')
                    return
                }// if
                
                // Возвращаем список удаленных файлов
                return response.data.doneFiles

            } else {
                console.log('Ошибка при передаче или сохранении файлов.\nСервер отвечает (код 200). Но нет подтверждения от multiupload.php, что файлы сохранены')
                alert('Ошибка (см. консоль)')
                return
            }// if
        } catch (e) {

            if(e.code === 'ERR_NETWORK') {
                // Нет подключения к серверу
                pushNotify( 'Нет подключения к серверу', 'notifyOrange')
                // console.log('Нет подключения к серверу')
                return
            }

            console.log(e)
            return
        }// try

    }// deleteFiles


    // Возврат элементов из picsToDelete в picsInDB (в сторе)
    function getBackFiles() {
        if(picsToDeleteStore.length > 0) 
        dispath({ type: 'AddToPicsInDB', picsInDB: picsToDeleteStore })// this.$store.commit('addToPicsArr', this.picsToDelete)
        // Очищаем массив
        dispath({ type: 'ClearPicsToDelete'})// this.picsToDelete = []
    }// getBackFiles


    
    return { delPicsToDelete, deleteNewPics, getBackFiles }

}// useDeletePics
